export const DISCOUNTS_BY_PROPERTY_VALUE = 'discountsByProperty';
export const APARTMENTS_VALUE = 'apartments';

export const PROMO_SEARCH_TYPES_ONBOARDING_COOKIE_KEY = 'promo_search_types_onboarding_shown';
